import { DESCRIPTION_IRIS } from 'src/templates/queries/iris';
import { JsonLdResult } from 'src/templates/queries/types';
import { getJsonLdResultPreferredValue } from 'src/utils/jsonld/getJsonLdResultPreferredValue';

export const getJsonLdResultDescription = (result: JsonLdResult) =>
  getJsonLdResultPreferredValue(result, DESCRIPTION_IRIS);
